import jsCookie from 'js-cookie'
import _getValue from 'lodash/get'
import { viewImage, openLink, isLeYou } from './utils/utils'
import { BUZZTYPE } from '@/utils/constants'

export default function install(Vue) {
  Vue.prototype.$cookie = jsCookie
  Vue.prototype.$viewImage = viewImage
  Vue.prototype.$openLink = openLink
  Vue.prototype.$getValue = _getValue
  Vue.prototype.$BUZZTYPE = BUZZTYPE
  Vue.prototype.$isLeYou = isLeYou
}
